import {createRouter, RouteRecordRaw, createWebHashHistory} from 'vue-router'
import NavView from "@/components/nav/NavView.vue"
const routes: Array<RouteRecordRaw> = [
  {
    path: '/', component: NavView,
    children: [
      {path: 'stock', component: () => import('@/views/stock/list.vue')},
      {path: 'industry', component: () => import('@/views/industry/list.vue')},
      {path: 'financial', component: () => import('@/views/financial/list.vue')},
      {path: 'symbol', component: () => import('@/views/symbol/list.vue')},
    ]
  },
  {path: '/stock_line_charts', component: () => import('@/views/stock/StockChartPage.vue')},

    // 晴雨表
  {path: '/stock/sentiments', component: () => import('@/views/stock/StockSentiments.vue')},
  {path: '/industry_sentiments_charts', component: () => import('@/views/industry/Sentiments.vue')},
  {path: '/industry_sentiments_full_charts', component: () => import('@/views/industry/SentimentFullChart.vue')},

  {path: '/mobile_home', component: () => import('@/views/MobileHome.vue')},
  {path: '/login', component: () => import('@/views/login/Login.vue')},
  {path: '/bind-otp', component: () => import('@/views/login/BindOtp.vue')},

  {path: '/symbol/sentiments', component: () => import('@/views/symbol/Sentiments.vue')},
  {path: '/symbol/sentiments_history', component: () => import('@/views/symbol/SentimentsHistory.vue')},
  {path: '/symbol/mobile_sentiments', component: () => import('@/views/symbol/SentimentsMobile.vue')},
  {path: '/symbol_line_charts', component: () => import('@/views/symbol/SymbolLinePage.vue')},
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router